import { render } from "./EstadosPlay.vue?vue&type=template&id=509e65c2"
import script from "./EstadosPlay.vue?vue&type=script&lang=js"
export * from "./EstadosPlay.vue?vue&type=script&lang=js"

import "./EstadosPlay.vue?vue&type=style&index=0&id=509e65c2&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__